import React, { useCallback } from 'react'
import { string } from 'prop-types'
import Field from '@groovehq/internal-design-system/lib/components/Field/Field'
import { useController } from 'react-hook-form'

import { styles } from './styles'

const AdditionalInfo = ({ className, control, updateDraft }) => {
  const {
    field: { onChange: onTagsChange, value: tagsValue },
  } = useController({
    name: 'tags',
    control,
  })

  const {
    field: { onChange: onNotesChange, value: notesValue },
  } = useController({
    name: 'notes',
    control,
  })

  const onNotesBlur = useCallback(
    e => {
      onNotesChange(e)
      updateDraft({ note: e.target.value })
    },
    [onNotesChange, updateDraft]
  )
  const onTagsBlur = useCallback(
    e => {
      onTagsChange(e)
      updateDraft({ tags: e.target.value.split(',') })
    },
    [onTagsChange, updateDraft]
  )

  return (
    <div className={className} css={styles.base}>
      <Field
        onChange={onNotesChange}
        onBlur={onNotesBlur}
        value={notesValue}
        label="Notes"
        placeholder="Add a note…"
        className="grui mb-11"
      />
      <Field
        onChange={onTagsChange}
        onBlur={onTagsBlur}
        value={tagsValue}
        label="Tags"
        placeholder="Add tags"
        className="grui mb-11"
      />
    </div>
  )
}

AdditionalInfo.propTypes = {
  className: string,
}

AdditionalInfo.defaultProps = {
  className: undefined,
}

export default AdditionalInfo
